import { firestore } from '@api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

export interface ActivityLog {
    id: string;
    section: string;
    sectionId: string;
    name: string;
    description: string;
    date: any;
}

export const ACTIVITY_LOGS_COLLECTION = 'activity-logs';

export const activityLogsRef = collection(firestore, ACTIVITY_LOGS_COLLECTION);
